// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Ritoppu_Model_FovMask = require("../Ritoppu.Model.FovMask/index.js");
var Ritoppu_Model_Player = require("../Ritoppu.Model.Player/index.js");
var Ritoppu_Model_Tile = require("../Ritoppu.Model.Tile/index.js");
var tileAt = function (stage) {
    return function (pos) {
        return Data_Maybe.fromMaybe(Ritoppu_Model_Tile.Wall.value)(Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(stage.tiles));
    };
};
var playerAt = function (stage) {
    return function (pos) {
        return Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Eq.eqInt)))(stage.player.pos)(pos);
    };
};
var itemAt = function (stage) {
    return function (pos) {
        return Data_Array.head(Data_Maybe.fromMaybe([  ])(Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(stage.items)));
    };
};
var initStage = function (size) {
    return {
        player: Ritoppu_Model_Player.initPlayer,
        tiles: Data_Map_Internal.empty,
        size: size,
        seen: Data_Set.empty,
        items: Data_Map_Internal.empty,
        fovMask: Ritoppu_Model_FovMask.initFovMask,
        creatures: Data_Map_Internal.empty
    };
};
var creatureAt = function (stage) {
    return function (pos) {
        return Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(stage.creatures);
    };
};
var availableToMoveTo = function (stage) {
    return function (pos) {
        return Ritoppu_Model_Tile.passibleThrough(tileAt(stage)(pos));
    };
};
var anybodyAt = function (stage) {
    return function (pos) {
        return Data_Map_Internal.member(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(pos)(stage.creatures);
    };
};
module.exports = {
    anybodyAt: anybodyAt,
    creatureAt: creatureAt,
    playerAt: playerAt,
    tileAt: tileAt,
    availableToMoveTo: availableToMoveTo,
    initStage: initStage,
    itemAt: itemAt
};
